class HamburgerController {
  constructor() {

  }
}

export default HamburgerController;
